<template>
  <div>
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="page-breadcrumb border-bottom">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-xs-12 align-self-center">
          <h5 class="font-medium text-uppercase mb-0">Wordpress Cache</h5>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="page-content container-fluid">
      <!-- ============================================================== -->
      <!-- Start Page Content -->
      <!-- ============================================================== -->

      <div class="card-body">
        <form class="needs-validation form-create-category" @submit.prevent="clearCache">
          <div class="d-block form-group">
            <label for="urls">Clear Urls <i>(Limit to 10 links at once)</i></label>
            <textarea
              v-model="urls"
              id="urls"
              class="form-control d-block"
              name="urls"
              rows="11"
              required 
              :placeholder="inputPlaceholder"
            />
            <div v-if="error" class="text-danger my-3">{{ error }}</div>
          </div>
          <div class="text-center">
            <button type="submit" class="mr-2 btn btn-primary" :disabled="isLoading">
              Clear Cache Urls
              <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
            </button>
          </div>
        </form>

        <div class="mt-3">
          <pre><b>Last Clear Time:</b> {{ lastClearTime }}</pre>
          <pre><b>Last Clear Urls:</b></pre>
          <pre>{{ lastClearUrls }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Utils from '@/utils'
import config from '@/config'
import WpWebhookApi from '@/api/wpWebhook'

const SAMPLE_REQUEST_PATHS = [
  '/blog/',
  '/blog/example-of-radical-innovation/',
  '/features/online-quiz-creator/'
]

const INPUT_PLACEHOLDER = config.baseEnv === 'production'
  ? SAMPLE_REQUEST_PATHS.map(path => `https://ahaslides.com${path}`).join('\n')
  : SAMPLE_REQUEST_PATHS.map(path => `https://dev.ahaslide.com${path}`).join('\n')

export default {
  name: "WordpressCache",
  data() {
    return {
      isLoading: false,
      urls: '',
      inputPlaceholder: INPUT_PLACEHOLDER,
      error: '',
      lastClearTime: '',
      lastClearUrls: '',
    }
  },
  methods: {
    async clearCache() {
      if (this.isLoading) return

      this.isLoading = true

      try {
        const links = this.makeLinks()
        this.validate(links)

        await WpWebhookApi.purgeCacheForMultipleUrls(links)
        this.lastClearTime = new Date().toLocaleString()
        this.lastClearUrls = links.join('\n')
        this.urls = ''

        Utils.showToastSuccess('Processing... It may take some minutes to get it done')
      } catch (error) {
        this.error = error.message
        Utils.showToastError(error.message)
      } finally {
        this.isLoading = false
      }
    },
    makeLinks() {
      return this.urls.split('\n').map(link => link.trim())
    },
    validate(links) {
      if (links.length > 10) {
        throw new Error('Limit to 10 links at once!')
      }

      for (let link of links) {
        if (!Utils.isValidUrl(link)) {
          throw new Error(`Invalid url: ${link}`)
        }
      }
    }
  }
}
</script>
